import React, { useContext } from 'react';
import { Redirect, Route, RouteProps } from 'react-router';
import { AuthContext } from '../../auth/AuthContext';
import PermissionsChecker, {CATEGORIES} from '../../utils/PermissionsChecker';

interface PrivateRouterProps extends RouteProps {
    category: string;
    requireWriteAccess?: boolean;
}

const PrivateRouter:React.FC<PrivateRouterProps> = (props) => {

    const authContext:any = useContext(AuthContext);
    const {userPermissions} = authContext
    const {category, requireWriteAccess} = props
    const isCategoryPermitted = requireWriteAccess
        ? PermissionsChecker.hasWriteAccess(category, userPermissions)
        : PermissionsChecker.isPermitted(category, userPermissions);
    if (userPermissions && (!isCategoryPermitted ||
        !PermissionsChecker.isPermitted(CATEGORIES.ADMIN_PORTAL, userPermissions))) {
        return <Redirect to="/403" path = {String(props.path)}/>
    }

    return <Route {...props} />

};

export default PrivateRouter;
